import { Box, Container, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        padding: "40px 0",
        marginTop: "auto", // Aby stopka zawsze była na dole strony
      }}
    >
      <Container maxWidth="lg">
        {/* Stopka: Prawa autorskie */}
        <Box
          sx={{
            borderTop: "1px solid #444",
            paddingTop: "25px",
            marginTop: "0px",
            textAlign: "center",
            color: "#000",
          }}
        >
          <Typography variant="body2" sx={{ color: "#000" }}>
            &copy; {new Date().getFullYear()} Allworks sp. z o.o.
          </Typography>
          <Typography variant="body2" sx={{ color: "#000" }}>
            ul. Brzozowa 14D 43-190 Mikołów
          </Typography>
          <Typography variant="body2" sx={{ color: "#000" }}>
            email: Michal.Jaskulski@allworks.pl, tel. +48 602 209 858
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
